<div class="backdrop" (click)="close()" [@fadein]="isOpen.toString()"></div>

<div class="sidenav" [@slidein]="isOpen.toString()">
  <div class="header">
    <button class="close" mat-icon-button (click)="close()"><mat-icon svgIcon="nav/close-white"></mat-icon></button>
    <img class="logo" height="10" src="assets/cui/logo/systematic-white.svg" alt="SYSTEMATIC">
    <div class="icon">
      <ng-content select="[mat-icon-button]"></ng-content>
    </div>
  </div>

  <div class="info">
    <ng-content select="cui-sidenav-info"></ng-content>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/sidenav/sidenav.component.html